import React from 'react';
export function AdvertorialHero() {
  return <header className="mb-8" data-id="element-211">
      <div className="flex items-center gap-2 mb-6" data-id="element-212">
        <span className="bg-gray-900 text-white text-xs font-bold px-2 py-1 uppercase tracking-wider" data-id="element-213">
          Health & Wellness
        </span>
        <span className="text-gray-500 text-xs uppercase tracking-wider" data-id="element-214">
          Sponsored Content
        </span>
      </div>

      <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight mb-4 font-serif" data-id="element-215">
        I Watched My Father Lose 3 Teeth Before 60. Here's What I Do Every Night
        to Make Sure It Doesn't Happen to Me
      </h1>

      <h2 className="text-xl md:text-2xl text-gray-600 leading-relaxed mb-6 font-normal" data-id="element-216">
        The 60-second routine that replaced painful flossing—and finally stopped
        the bleeding that worried my dentist
      </h2>

      <div className="flex items-center gap-3 border-t border-b border-gray-200 py-4" data-id="element-217">
        <div className="w-10 h-10 bg-gray-200 rounded-full overflow-hidden" data-id="element-218">
          <img src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&q=80&w=100" alt="Rachel M." className="w-full h-full object-cover" data-id="element-219" />
        </div>
        <div className="text-sm" data-id="element-220">
          <p className="font-bold text-gray-900" data-id="element-221">By Rachel M.</p>
          <p className="text-gray-500" data-id="element-222">February 2026 • 8 min read</p>
        </div>
      </div>
    </header>;
}